module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAFCAYAAACJmvbYAAAABHNCSVQICAgIfAhkiAAAADlJREFUCJlj+A8BCQxI4P///wb///+/wPD///8EZAVQiQf///83gKmEKchHkUAyKuH///8fMCRwAQCELT+HEmNmSAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/chev_up_light.png
// module id = 904
// module chunks = 0